// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler;

export const DispatchResetSkus: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/PartFinder/ResetSkus",
    });
};

export const chain = [DispatchResetSkus];

const resetSkus = createHandlerChainRunnerOptionalParameter(chain, {}, "ResetSkus");
export default resetSkus;
